import React from 'react'
import TransitionLink from 'gatsby-plugin-transition-link'
import gsap from 'gsap'

function LinkAnimate(props) {
  const { to, children, className = '', style } = props

  let currentLink = to
  if (currentLink !== '/') {
    currentLink = `/${to}/`
  }

  const entryAnimation = (entry, node) => {
    const page = node.querySelector('.page')

    gsap.set(page, {
      alpha: 0,
    })

    gsap.to(page, 0.4, {
      alpha: 1,
      y: 0,
      clearProps: 'transform',
    })
  }

  const exitAnimation = (exit, node) => {
    const page = node.querySelector('.page')

    gsap.set(page, {
      alpha: 1,
      y: 0,
    })

    gsap.to(page, 0.3, {
      alpha: 0,
      y: 5,
    })
  }

  return (
    <TransitionLink
      activeClassName="is-active"
      className={className}
      style={style}
      to={currentLink}
      exit={{
        trigger: ({ exit, node }) => exitAnimation(exit, node),
        length: 0.4,
      }}
      entry={{
        trigger: ({ entry, node }) => entryAnimation(entry, node),
        length: 0.4,
        zIndex: 2,
      }}
    >
      {children}
    </TransitionLink>
  )
}

export default LinkAnimate
